import { Link, useRouteError } from "react-router-dom";

interface ErrorRoute {
  statusText: string;
  message: string;
}

export default function ErrorPage() {
  const error = useRouteError() as ErrorRoute;
  return (
    <div className="d-flex flex-column align-items-center justify-content-center min-vh-100 text-center px-4">
      <h1 className="fw-800 text-primary display-4 mb-2">Oops!</h1>
      <p className="text-muted mb-1">Sorry, an unexpected error has occurred.</p>
      <p className="text-muted fst-italic mb-4">{error.statusText || error.message}</p>
      <Link to="/" className="btn btn-primary">
        Go Home
      </Link>
    </div>
  );
}
